import { registerSW } from "virtual:pwa-register";
import { Box, CircularProgress, type SxProps, type Theme } from "@mui/material";
import { useEffect, useState } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { MyPlannDialog } from "web_myplann/Shared/Components/MyPlannDialog";

const eventData = {
	type: "MYPLANN_UPDATE_AVAILABLE",
};

export const updateSw = registerSW({
	onNeedRefresh() {
		window.postMessage(eventData);
	},
});

const dialogSx: SxProps<Theme> = {
	backdropFilter: "blur(3.2px)",
	position: "absolute",
	zIndex: (t) => t.zIndex.modal,
	top: "0px",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	height: "100vh",
	width: "100vw",
};

const UpdateVersionDialog = () => {
	const { t } = useResource();
	const [showDialog, setShowDialog] = useState(false);
	const [updating, setUpdating] = useState(false);
	useEffect(() => {
		const listener = (ev: MessageEvent<unknown>) => {
			if (typeof ev.data !== "object" || ev.data === null) {
				return;
			}

			if ((ev.data as { type?: unknown }).type === eventData.type) {
				setShowDialog(true);
			}
		};

		window.addEventListener("message", listener);
		return () => {
			window.removeEventListener("message", listener);
		};
	}, [setShowDialog]);

	if (updating) {
		return (
			<Box sx={dialogSx}>
				<CircularProgress />
			</Box>
		);
	}

	return (
		<MyPlannDialog
			open={showDialog}
			handleResult={async (a) => {
				setShowDialog(false);
				if (a) {
					setUpdating(a);
					updateSw();
				}
			}}
			modalTitle={t(Resources.VersionUpdate.modalTitle)}
			modalContent={t(Resources.VersionUpdate.modalContent)}
		/>
	);
};

export default UpdateVersionDialog;
